import { styled } from '@mui/material/styles';

export const StyledPlaceholder = styled('div')<{
  disabled: boolean;
}>(({ disabled, theme }) => ({
  color: disabled ? theme.palette.text.disabled : theme.palette.text.primary,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: 'calc(100% - 8px)',
}));
